import React, { useEffect } from "react";
import PageHeader from "app/main/shared-components/page-header/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "app/store";
import PaginationBar from "app/main/shared-components/pagination-bar/PaginationBar";
import { useTranslation } from "react-i18next";
import SearchSaleTable from "./SearchSaleTable";
import SaleTable from "./SaleTable";
import { fetchSales } from "app/main/sales/store/sales-list.slice";
import { setSalesFilters } from "app/main/sales/store/filter-sales.slice";

const SalesList: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const filters = useSelector((s: AppState) => s.sales.filters);
  const { loading, response, rows } = useSelector(
    (s: AppState) => s.sales.list
  );

  const pageSize = response?.reservations?.size || filters.size || 20;
  const totalPages = response?.reservations?.totalPages || 1;
  const currentPageZeroBased = response?.reservations?.number ?? filters.page ?? 0;

  return (
    <div>
      <PageHeader
        title={t("Sale List", "Sale List")}
        desc={t("Sale List", "Sale List")}
      />
      <SearchSaleTable />
      <SaleTable rows={rows} loading={loading} response={response} />
      <PaginationBar
        totalPages={totalPages}
        currentPage={currentPageZeroBased + 1}
        onPageChange={(uiPage: number) => {
          const newPage = uiPage;
          dispatch(
            setSalesFilters({ ...filters, page: newPage, size: pageSize })
          );
          dispatch(fetchSales({ ...filters, page: newPage, size: pageSize }));
        }}
      />
    </div>
  );
};

export default SalesList;